import { restClient } from '@/Core'

import { toQuota } from '../Helpers/diskResponse'

import type { DiskQuota } from '../Contracts/DiskNode'

/** Квота: особистий простір і простори, якими я керую — `GET /services/disk/quota`. */
export const LoadDiskQuotaTask = async (): Promise<DiskQuota> => {
    const response = (await restClient.get('/services/disk/quota', {}, { forceRefresh: true })) as unknown

    return toQuota(response)
}
